import { jsx as e } from "react/jsx-runtime";
import { useMultiStyleConfig as n, chakra as s } from "@chakra-ui/react";
const d = ({
  children: t,
  isOpen: o = !1,
  variant: a = "default",
  ...r
}) => {
  const i = n("FloatingBottomBar", { variant: a });
  return /* @__PURE__ */ e(
    s.div,
    {
      "data-open": o ? "" : void 0,
      "data-testid": "floating-bottom-bar",
      __css: i.container,
      ...r,
      children: t
    }
  );
};
export {
  d as FloatingBottomBar
};
//# sourceMappingURL=FloatingBottomBar.es.js.map
